<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">
    <div class="bb-page-header noPrint">
      <div class="bb-page-title-block">
        <h2 class="bb-page-title">{{ 'Print' | transloco }}</h2>
      </div>

      <div class="bb-header-actions">
        <button (click)="printAndSaveTodayOrders()" class="bb-btn bb-btn-primary">
          {{ 'Print' | transloco }}
        </button>
      </div>
    </div>

    <div class="bb-table-card">
      <div class="bb-table-scroll">
        <table class="bb-table">
          <thead>
            <tr>
              <th class="mat-header-cell-custom">{{ "client name" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "Phone Number" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "address" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "created by" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "total" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "note" | transloco }}</th>
              <th class="mat-header-cell-custom">{{ "delivered" | transloco }}</th>
              <th class="mat-header-cell-custom noPrint"></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let order of selectedDeliveryOrders; let i = index">
              <td class="mat-cell-custom bb-font-bold">
                {{ order.client_name }}
              </td>

              <td class="mat-cell-custom">
                <div class="bb-text-stack">
                  <span>{{ order.phone_number }}</span>
                  <small>{{ order.another_phone }}</small>
                </div>
              </td>

              <td class="mat-cell-custom">
                {{ order.address }}
              </td>

              <td class="mat-cell-custom">
                {{ order.user_last_name }}
              </td>

              <td class="mat-cell-custom bb-price">
                {{ order.total }} {{ "egp" | transloco }}
              </td>

              <td class="mat-cell-custom"></td>

              <td class="mat-cell-custom"></td>

              <td class="mat-cell-custom noPrint bb-text-center">
                <button class="bb-btn bb-btn-danger bb-btn-sm" (click)="deleteOrder(i)">
                  {{ "Delete" | transloco }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>